module.exports = __webpack_public_path__ + "img/database.0376a5c9.png";